module.exports = __webpack_public_path__ + "static/Pascal_Watwat-e71ce167a4fdbe7d96a049db15c7410c.jpg";